import React, { Component } from 'react'
import SideMenu from '../admin/SideMenu';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import TopMenu from '../admin/TopBar';
import { appDatabasePrimaryFunctions, base } from '../../base';
import UploadImage from '../utils/UploadImage';
import swal from 'sweetalert2';
import '../../styles/css/AdminMain.css';
import BasicDropzone from '../utils/Dropzone';
import { validUrl } from "../utils/HelpfulFunction";

class SetUpReveal extends Component {
    constructor(props) {
        super(props);
        this.UploadImage = new UploadImage();

        this.state = {
            revealQuestionList: [],
            currentHintsList: [],
            currentAnswerList: [],
            name: "",
            editImage: '',
            editCorrectSelectImage: '',
            selected: {},
            newAnswerText: '',
            newAnswerImage: null,
            modal: false,
            editing: false,
            loading:true,
            gifSelectionImage: null,
            gifSelectionImagePreview: {},
            correctSelectImage: null,
            correctSelectImagePreview: {},
            questionText: ""
        };
        this.toggle = this.toggle.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
      this.revealQuestionListRef = base.syncState(`revealQuestionList`, {
        context: this,
        state: 'revealQuestionList',
        asArray: true
      });
      this.setState({
        loading: false
      })
    }

    componentWillUnmount() {
      base.removeBinding(this.revealQuestionListRef);
      URL.revokeObjectURL(this.state.gifSelectionImagePreview.preview);
    }

    handleChange(evt){
        const target = evt.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({ [evt.target.name]: value });
    }

    handleDropzoneUpload = (name, url, info) => {
        const nameToUpdate = name + "Preview"
        this.setState({
            [name]: url || null,
            [nameToUpdate]: url ? ({
                fileToUpdate: info && info.file,
                preview: info && info.preview
            }) : {}
        });
    }

    toLocalArray(){
        let array = this.state.currentHintsList;
        let newHintText = this.state.newHintText || "";
        newHintText = newHintText.trim();
        if(newHintText === ""){
            swal({
                title: "Hint is blank",
                text: 'Please enter an answer and try again',
                type: 'warning',
                confirmButtonText: 'Ok'
            });
            return;
        }
        if(newHintText.length > 100){
            swal({
                title: "Hint Is Too Long",
                text: 'Hint cannot be longer than 100 characters',
                type: 'warning',
                confirmButtonText: 'Ok'
            });
            return;
        }
        const hintId = appDatabasePrimaryFunctions.ref().push().key;
        let newAnswerObject = {hintText: newHintText, id: hintId, order:array.length+1};
        array = array.concat(newAnswerObject);
        this.setState({
            currentHintsList: array,
            newHintText: "",
            loading: false,
        })
    }

    changeOrder(item, direction, arrayName, index){
        let array = this.state[arrayName];
        let originalOrder = item.order || index + 1;
        let newOrder = originalOrder - direction;
        if((originalOrder === 1 && direction === 1) || (originalOrder === array.length && direction ===-1)) return;
        //remove the item from the array
        array.splice(index, 1);
        // Sort the array by the 'order' property after updating orders
        array.sort((a, b) => a.order - b.order);
        // Calculate the new index for insertion.
        let newIndex = newOrder - 1;
        //insert item into proper position in array
        array.splice(newIndex, 0, item);
        // Update 'order' properties to reflect the current array indices.
        array.forEach((item, idx) => {
            array[idx].order = idx + 1; // Make 'order' 1-based again.
        });
        //save to state
        this.setState({
            [arrayName]: array
        })
    }

    editAnswer(item,index, arrayName){
        const answerText = item.answerText;
        const answerImage = item.answerImage;
        this.removeFromArray(index, arrayName);
        if(arrayName === "currentAnswerList"){
            this.setState({
                newAnswerText: answerText,
                newAnswerImagePreview: {
                    preview: answerImage
                },
                newAnswerImage: null,
            })
        } else {
            this.setState({
                newHintText: item.hintText
            })
        }
    }

    removeFromArray(index, nameOfArray){
        let array = this.state[nameOfArray];
        array.splice(index, 1);
        while(index < array.length){
            if(array[index]){
                array[index].order = index+1
            } else {
                index = array.length+1;
            }
            index++
        }
        this.setState({
            [nameOfArray]: array
        })
    }

    async answerToLocalArray(){
        let array = this.state.currentAnswerList;
        const newAnswerImage = this.state.newAnswerImagePreview || null;
        let newAnswerImagePreview = null;
        if(newAnswerImage){
            newAnswerImagePreview = newAnswerImage.preview;
        }
        if(array.length>3){
            swal({
                title: "Too many answers",
                text: 'Only 4 answers are allowed per question',
                type: 'warning',
                confirmButtonText: 'Ok'
            });
            return;
        }
        let imageUrl = null;
        if(newAnswerImagePreview && !validUrl(newAnswerImagePreview)){
            this.setState({
                loading:true
            });
            await this.UploadImage.upload_file(newAnswerImage.fileToUpdate).then(res => {
                if(res && res.imageUrl){
                    imageUrl = res.imageUrl;
                }
            })
        } else if(newAnswerImagePreview && validUrl(newAnswerImagePreview)){
            imageUrl = newAnswerImagePreview;
        }
        if(newAnswerImagePreview && !imageUrl){
            this.setState({
                loading:false
            });
            swal({
                title: 'Image cannot be uploaded',
                text: 'There was some issue with the image upload, please reupload and try again',
                type: 'warning',
                confirmButtonText: 'Ok'
            })
            return;
        }
        const answerId = appDatabasePrimaryFunctions.ref().push().key;
        let newAnswerObject = {id: answerId, answerImage: imageUrl, answerImagePreview: newAnswerImagePreview, order:array.length+1};
        array = array.concat(newAnswerObject);
        this.setState({
            currentAnswerList: array,
            newAnswerText: "",
            newAnswerImagePreview: null,
            loading: false,
        })
    }

    createItem() {
        const name = this.state.name;
        const revealQuestionList = this.state.revealQuestionList || [];
        const gifSelectionImage = this.state.gifSelectionImage || this.state.editImage;
        const correctSelectImage = this.state.correctSelectImage || this.state.editCorrectSelectImage;
        const questionText = this.state.questionText.trim();
        const hintsList = this.state.currentHintsList;
        let answerList = this.state.currentAnswerList;
        const vm = this;
        if(!name  || !gifSelectionImage){
            swal({
                title: 'Oh uh!',
                text: 'Make sure the name and unblurr image are added!',
                type: 'warning',
                confirmButtonText: 'Ok'
              })
            return;
        } else if(name.length > 50){
            swal({
                title: 'Oh uh!',
                text: 'Name cannot be longer than 50 characters!',
                type: 'warning',
                confirmButtonText: 'Ok'
            })
            return;
        } else if(!questionText) {
            swal({
                title: 'Oh uh!',
                text: 'Make sure to add question text',
                type: 'warning',
                confirmButtonText: 'Ok'
            })
            return;
        } else if(!correctSelectImage){
            swal({
                title: 'Oh uh!',
                text: 'Make sure to add a correct answer selection image',
                type: 'warning',
                confirmButtonText: 'Ok'
            })
        }

        let itemToRemove = null; // This will store the item to remove

        for (let i = 0; i < answerList.length; i++) {
            const answer = answerList[i];
            if(answer.correct){
                itemToRemove = answer;
                itemToRemove['order'] = itemToRemove.order || (i + 1);
                answerList.splice(i, 1); // Remove the item from the array
                break; // Exit the loop if only removing the first found item
            }
        }

        const correctAnswer = {};
        const answerId = appDatabasePrimaryFunctions.ref().push().key;
        correctAnswer['answerImage'] = correctSelectImage;
        correctAnswer['id'] = answerId;
        correctAnswer['correct'] = true;
        correctAnswer['order'] = itemToRemove.order;
        answerList.push(correctAnswer);

        if(answerList.length === 0 || answerList.length === 1 || answerList.length > 4){
            swal({
                title: "Incorrect Answers",
                text: 'You need to add more answers or, if you have more than 4, take away answers to this question',
                type: 'warning',
                confirmButtonText: 'Ok'
            })
            return;
        }

        for(let answer in answerList){
            answerList[answer].answerImagePreview = null;
        }

        answerList = answerList.sort(() => Math.random() - 0.5)

        for(let questionIndex in revealQuestionList){
            const question = revealQuestionList[questionIndex];
            if(question.name === name && !this.state.selected){
                swal({
                    title: 'Oh uh!',
                    text: "This name already exists! Pick another name",
                    type: 'warning',
                    confirmButtonText: 'Ok'
                })
                return;
            }
        }
        this.setState({
            loading:true
        })
        const question = {};
        question.name = name;
        question.questionText = questionText;
        question.gifSelectionImage = gifSelectionImage;
        question.hints = hintsList;
        question.answers = answerList;
        console.log(this.state.editing, this.state.selected)
        const questionId = this.state.editing ? this.state.selected.id || this.state.selected.key : appDatabasePrimaryFunctions.ref().push().key;
        question.id = questionId;
        base.post(`revealQuestionList/${questionId}`, {
            data: question,
            then(err){
                if(!err){
                    vm.setState({
                        loading: false,
                        name: "",
                        gifSelectionImage: null,
                        fileUploaded: false,
                        editImage: "",
                        editImageUnblur: "",
                        modal:false,
                        currentHintsList: [],
                        currentAnswerList: []
                    })
                    swal({
                        title: vm.state.editing ? 'Edited Successfully!' : 'Created Successfully!',
                        type: 'success',
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: true,
                        timer: 10000
                    })
                } else {
                    vm.setState({loading:false})
                    swal({
                        title: 'There was some error!',
                        text: 'Try again and if the problem persists try logging out and logging back in',
                        type: 'error',
                        confirmButtonText: 'Ok'
                    })
                    // console.log(err)
                }
            }
        })
    }

    editItem(event){
        event.preventDefault();
        const array = this.state.revealQuestionList;
        const question = array[event.target.value];
        const hintsList = question.hints || [];
        const answerList = question.answers || [];
        let correctAnswerImage;
        let correctAnswerId;
        for(const answerIndex in answerList){
            const answer = answerList[answerIndex];
            if(answer.correct){
                correctAnswerImage = answer.answerImage;
                correctAnswerId = answer.id;
                // answerList.splice(parseInt(answerIndex), 1);
            }
        }
        let fileUploaded = false;
        if(!question){
            swal({
                title: 'Oh uh!',
                text: 'Something went wrong, refresh the page and try again!',
                type: 'warning',
                confirmButtonText: 'Ok'
            })
            return;
        }
        this.setState({
            modal: !this.state.modal,
            selected: question,
            name: question.name,
            questionText: question.questionText,
            editingImagePreview: question.gifSelectionImage,
            correctSelectImagePreview: correctAnswerImage,
            editCorrectSelectImage: correctAnswerImage,
            correctAnswerId: correctAnswerId,
            editImage: question.gifSelectionImage,
            fileUploaded: fileUploaded,
            editing: true,
            currentHintsList: hintsList.slice(0),
            currentAnswerList: answerList.slice(0)
        });
    }

    toggle() {
      this.setState({
        modal: !this.state.modal,
        selected: {},
        name: "",
        editingImagePreview: null,
        editingImageUnblurPreview: null,
        editImage: '',
        editImageUnblur: "",
        editing: false,
        fileUploaded: false,
        currentHintsList: [],
        currentAnswerList: [{answerImagePreview: "", order: 1, correct: true}]
      });
    }

    deleteItem(e){
      e.preventDefault();
      const array = this.state.revealQuestionList;
      const index = array[e.target.value];
      swal({
            title: 'Delete?',
            text: 'Are you sure you want to do this?  You will no longer be able to use it in any new games',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Delete',
        }).then((result)=>{
          if (result.value) {
            base.remove('revealQuestionList/' + index.key, function(err) {
              if(err){
                swal({
                  title: 'There was some error!',
                  text: 'Try again and if the problem persists try logging out and logging back in',
                  type: 'error',
                  confirmButtonText: 'Ok'
                })
              }
            })
          }
        })
    }

    setAsCorrect(e){
        let answers = this.state.currentAnswerList;
        for(let answer in answers){
            if(answer == e){
                answers[answer].correct = true
            } else {
                answers[answer].correct = false
            }
        }
        this.setState({
            currentAnswerList: answers
        })
    }

    render() {
        const revealQuestionList = this.state.revealQuestionList;
        let currentHintsList = this.state.currentHintsList;
        let currentAnswerList = this.state.currentAnswerList || [];
        let selected = this.state.selected;
        const gifSelectionImagePreview = this.state.gifSelectionImagePreview || {};
        const correctSelectImagePreview = this.state.correctSelectImagePreview || {};
        const newAnswerImagePreview = this.state.newAnswerImagePreview || {};
        const correctSelectImage = this.state.correctSelectImage || "";
        if(Object.keys(selected).length === 0){
            selected = null
        }
        if(currentHintsList.length > 1){
            currentHintsList = currentHintsList.sort((a,b)=>a.order-b.order);
        }

        if(currentAnswerList.length > 1){
            currentAnswerList = currentAnswerList.sort((a,b)=>a.order-b.order);
        }

        console.log(currentAnswerList)

        return (
          <div className="admin-wrapper">
            <div className="loading-screen" style={{display: this.state.loading ? 'block' : 'none' }}/>
            <SideMenu/>
            <TopMenu/>
            <div className="admin-main-panel">
              <div className="card">
                <div className="card-body">
                    <p className="admin-header-text" style={{marginBottom:0}}>Reveal Questions</p>
                    <p className="admin-subheader-text">These are what picks will appear during your contest!</p>
                    <button className="btn btn-primary btn-lg create-prize-button" style={{fontSize:20,marginLeft:20}} onClick={this.toggle}>Add</button>
                    <div className="admin-grid-container four-columns" style={{marginTop:20}}>
                      {
                        revealQuestionList.map(function(item,i){
                          return <div key={i} className="card">
                              <div className="card-body" align="center">
                                <p style={{marginTop:5}}>{item.name}</p>
                                <p>
                                  <img width="80%" height="auto" src={item.gifSelectionImage} alt=""/>
                                </p>
                                <button className="btn btn-primary btn-lg edit-button" style={{ marginRight:5, marginBottom:10}} onClick={this.editItem.bind(this)} value={i}><span className="fa fa-ellipsis-v"/> Edit</button>
                                <button className="btn btn-primary btn-lg delete-button" style={{marginBottom:10}} onClick={this.deleteItem.bind(this)} value={i}><span className="fa fa-trash-o"/> Delete</button>
                              </div>
                            </div>
                        }, this)
                      }
                    </div>
                  </div>
                </div>
              </div>
            <Modal isOpen={this.state.modal} toggle={this.toggle} style={{width: '90%'}} id="myModal">
              <div className="loading-screen" style={{display: this.state.loading ? 'block' : 'none' }}/>
              <ModalHeader toggle={this.toggle}>Add</ModalHeader>
                <ModalBody>
                  <div className="container-out">
                    <div className="question-box question-form">
                        <div className="container">
                            <h4>Question Info</h4>
                            <div className="form-group">
                                <label htmlFor="name">Name</label>
                                <input type="text" id="name" name="name" className="form-control" value={this.state.name} onChange={this.handleChange} placeholder="A unique name to help with identification"/>
                            </div>
                            <div className="form-group" >
                                <label htmlFor="questionText">Question Text</label>
                                <input type="text" id="questionText" name="questionText" className="form-control" value={this.state.questionText} onChange={this.handleChange} placeholder="Which Player Is This?"/>
                            </div>
                        </div>
                        <div className="container">
                            <h4>Correct Answer</h4>
                            <div className="form-group" align="center">
                                <label htmlFor="gifSelectionImage" style={{width:'100%'}}>Unblurr Image</label>
                                <BasicDropzone
                                    name="gifSelectionImage"
                                    accept={{'image/*': []}}
                                    multiple={false}
                                    maxSize={2200000}
                                    value={gifSelectionImagePreview.preview || this.state.editImage || undefined}
                                    uploadFn={(file) => this.UploadImage.upload_file(file)}
                                    onUploadStart={() => this.setState({loading: true})}
                                    onUploadComplete={() => this.setState({loading: false})}
                                    onUploaded={this.handleDropzoneUpload}
                                />
                            </div>
                            <div className="form-group" align="center">
                                <label htmlFor="gifSelectionImage" style={{width:'100%'}}>Select Image</label>
                                <BasicDropzone
                                    name="correctSelectImage"
                                    accept={{'image/*': []}}
                                    multiple={false}
                                    maxSize={2200000}
                                    value={correctSelectImagePreview.preview || this.state.editCorrectSelectImage || undefined}
                                    uploadFn={(file) => this.UploadImage.upload_file(file)}
                                    onUploadStart={() => this.setState({loading: true})}
                                    onUploadComplete={() => this.setState({loading: false})}
                                    onUploaded={this.handleDropzoneUpload}
                                />
                            </div>
                            <h6>Hints</h6>
                            <div className="form-group">
                                <label htmlFor="newHintText">Add Hint Text: </label>
                                <input id="newHintText" name="newHintText" type="text" value={this.state.newHintText} onChange={this.handleChange} className="form-control" placeholder="A hint to help your fans"/>
                            </div>
                            <div>
                                <button className="btn btn-primary btn-lg" onClick={()=>this.toLocalArray()}><span className="fa fa-plus"/> ADD HINT</button>
                            </div>
                            <ol>
                                {
                                    currentHintsList.map(function(item,index){
                                        return(
                                            <li key={index} style={{marginTop: 10}}>Hint: {item.hintText}
                                                <span style={{marginLeft:"40px"}}>
                                                    <div style={{display:"inline-block", marginLeft:10}}>
                                                        <button style={{display: index === 0?"none":""}} onClick={()=>this.changeOrder(item, 1, "currentHintsList", index)}>⬆</button>
                                                        <button style={{display: currentHintsList.length === index+1? "none":""}} onClick={()=>this.changeOrder(item, -1, "currentHintsList", index)}>⬇</button>
                                                    </div>
                                                    <button className="btn btn-primary btn-admin" style={{marginLeft:"40px"}} onClick={()=>this.editAnswer(item,index,"currentHintsList")}><span className="fa fa-pencil"/></button>
                                                    <button className="btn btn-danger btn-admin" style={{float:"right"}} onClick={()=>this.removeFromArray(index, "currentHintsList")}><span className="fa fa-trash"/></button>
                                                </span>
                                            </li>
                                        )
                                    }, this)
                                }
                            </ol>
                        </div>
                        <div className="container">
                            <h4>Other Answers</h4>
                            <div className="form-group">
                                <label className="col-md-10 col-form-label" htmlFor="companyTitle">Add Answer Image: </label>
                                <BasicDropzone
                                    key={'newAnswerImage-' + currentAnswerList.length}
                                    name="newAnswerImage"
                                    accept={{'image/*': []}}
                                    multiple={false}
                                    maxSize={2200000}
                                    value={newAnswerImagePreview.preview || undefined}
                                    uploadFn={(file) => this.UploadImage.upload_file(file)}
                                    onUploadStart={() => this.setState({loading: true})}
                                    onUploadComplete={() => this.setState({loading: false})}
                                    onUploaded={this.handleDropzoneUpload}
                                />
                            </div>
                            <center>
                                <button className="btn btn-primary btn-lg" onClick={()=>this.answerToLocalArray()}><span className="fa fa-plus"/> ADD ANSWER</button>
                            </center>
                            <ol>
                                {
                                    currentAnswerList.map(function(item,index){
                                        if(item.correct && !selected && correctSelectImagePreview && correctSelectImagePreview.preview){
                                            item['answerImage'] = correctSelectImagePreview.preview;
                                        } else if(item.correct && selected && correctSelectImagePreview && correctSelectImagePreview.preview){
                                            item['answerImage'] = correctSelectImagePreview.preview;
                                        }
                                        return(
                                            <li key={index} style={{marginTop: 10}}>Answer:
                                                <img src={item.answerImagePreview || item.answerImage} alt="" style={{maxHeight: 50, maxWidth: "100%", width: "auto", height: "auto", verticalAlign: "middle", display: (item.answerImagePreview || item.answerImage) ? "" : "none"}}/>
                                                <span style={{marginLeft:"40px"}}>
                                                    <div style={{display:"inline-block", marginLeft:10}}>
                                                        <button style={{display: index === 0?"none":""}} onClick={()=>this.changeOrder(item, 1, "currentAnswerList", index)}>⬆</button>
                                                        <button style={{display: currentAnswerList.length === index+1? "none":""}} onClick={()=>this.changeOrder(item, -1, "currentAnswerList", index)}>⬇</button>
                                                    </div>
                                                    {!item.correct &&
                                                        <>
                                                            <button className="btn btn-primary btn-admin" style={{marginLeft:"40px"}} onClick={()=>this.editAnswer(item,index, "currentAnswerList")}><span className="fa fa-pencil"/></button>
                                                            <button className="btn btn-danger btn-admin" style={{float:"right"}} onClick={()=>this.removeFromArray(index, "currentAnswerList")}><span className="fa fa-trash"/></button>
                                                        </>
                                                    }
                                                </span>
                                            </li>
                                        )
                                    }, this)
                                }
                            </ol>
                        </div>
                      <div className="form-group text-center">
                        <button className="btn btn-primary btn-lg submit-button" id="submitButton" onClick={()=>this.createItem()}>Submit</button>
                      </div>
                    </div>
                  </div>
                </ModalBody>
            </Modal>
         </div>
        );
    }
}

export default SetUpReveal
